import React from 'react'
import { Field, reduxForm } from 'redux-form'

import { Input } from 'Components/Form/Input/index'
import SubmitButton from 'Components/Form/SubmitButton'
import Link from 'Components/Link'
import { MessageError } from 'Components/Message/Error'
import { validate } from './validate'
import { PATHS } from 'Config/Routing/paths'

export let LoginFormUnstyled = props => {
  return (
    <div className={props.className}>
      <div className="form-container">
        <h1>Log In</h1>
        {renderGeneralErrorMessage()}
        <div className="form-inputs">
          <Field
            name="username"
            type="text"
            component={Input}
            icon="user"
            id="username"
            placeholder="Username"
            test-id="username"
          />
          <Field
            name="password"
            type="password"
            component={Input}
            icon="password"
            id="password"
            placeholder="Password"
            test-id="password"
          />
        </div>
        <SubmitButton
          value="Log In"
          id="login-submit"
          onClick={props.handleSubmit}
        />
        <div className="under-form">
          <Link text="Forgot password" to={PATHS.main.requestPass} />
          <p>Don’t have an account yet?</p>
          <Link text="Sign up" underlined={true} />
        </div>
      </div>
    </div>
  )

  /**
   *
   * @returns {*}
   */
  function renderGeneralErrorMessage() {
    return props.errorMessage ? (
      <MessageError message={props.errorMessage} />
    ) : null
  }
}

LoginFormUnstyled = reduxForm({
  // a unique name for the form
  form: 'login',
  validate: validate,
})(LoginFormUnstyled)



// WEBPACK FOOTER //
// ./src/Containers/Form/Login/unstyled.js